import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppTypeService {
  constructor() {}

  get isDefault() {
    return environment.app_type === 'default';
  }

  get isPass() {
    return environment.app_type === 'pass';
  }
}
